import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const CancellationAndRefundPolicy = () => {
  return (
    <div className="container px-4 pt-5 mt-5">
      <h2>Cancellation & Refund Policy</h2>
      <p>Last updated on 23-01-2025 17:41:14</p>
      <p>
        RUSH TECHNOLOGIES believes in helping its customers as far as possible and has therefore adopted a liberal cancellation policy. Under this policy:
      </p>
      <ul>
        <li>
          Cancellations will be considered only if the request is made immediately after placing the order. However, the cancellation request may not be entertained if the orders have been communicated to the vendors/merchants and they have initiated the process of shipping them.
        </li>
        <li>
          RUSH TECHNOLOGIES does not accept cancellation requests for perishable items like flowers, eatables, etc. However, refund/replacement can be made if the customer establishes that the quality of the product delivered is not good.
        </li>
        <li>
          In case of receipt of damaged or defective items, please report the same to our Customer Service team. The request will, however, be entertained once the merchant has checked and determined the same at their own end. This should be reported within 30 days of receipt of the products.
        </li>
        <li>
          If you feel that the product received is not as shown on the site or as per your expectations, you must bring it to the notice of our customer service within 30 days of receiving the product. The Customer Service Team, after reviewing your complaint, will take an appropriate decision.
        </li>
        <li>
          For products that come with a warranty from manufacturers, please refer the issue to them directly.
        </li>
        <li>
          In case of any refunds approved by RUSH TECHNOLOGIES, it will take 9-15 business days for the refund to be processed to the end customer.
        </li>
      </ul>
    </div>
  );
};

export default CancellationAndRefundPolicy;
